import apiClient from '@/api/client'

export default {
  fetchUsersForExperimentSearchFilter() {
    return apiClient.get('users/same-logged-user-clients')
  },
}
